// components/LoadingOverlay.tsx
import LoadingIcon from "./LoadingIcon";
import "static/css/common.css";

interface Props {
  display?: string;
  width?: string;
  height?: string;
}

const LoadingOverlay: React.FC<Props> = ({ display, width, height }) => {
  const divStyle: React.CSSProperties = {
    display: display || "none",
    width: width || "100%", // Default to 100% if width is not provided
    height: height || "100%", // Default to 100% if width is not provided
  };

  return (
    <>
      <div
        id="overlay"
        style={divStyle}
        className="fullscreen-loading-container"
      >
        <LoadingIcon width="5vw" />
      </div>
    </>
  );
};

export default LoadingOverlay;
